import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable, Link } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames, firstImageProperty } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps, useModal, VideoImage, VideoPlayer } from '@shapeable/ui';
import { EntityCuratorFootMeta } from './entity-curator-foot-meta';
import { VERY_LIGHT_BROWN } from '../../theme';
import { filter } from 'lodash';
const cls = classNames('post-curator-card');

// -------- Types -------->

// -------- Props -------->

export type LinkCuratorCardProps = EntityCardProps & { 
  entity?: Link;
};

export const LinkCuratorCardDefaultProps: Omit<LinkCuratorCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 5,
  showDescription: true,
  showTypeHeader: false,
  showDescriptionDivider: false,
  showExternalLink: false,
  useLink: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const FootMetaStyles = breakpoints({
  base: css`
    
  `,
});

const ImageStyles = breakpoints({
  base: css`
    min-width: 100px;
  `,
});

const VideoStyles = breakpoints({

});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    VideoImage: styled(VideoImage)`${ImageStyles}`,
    Video: styled(VideoPlayer)`${VideoStyles}`,
    FootMeta: styled(EntityCuratorFootMeta)`${FootMetaStyles}`,
};

export const LinkCuratorCard: Shapeable.FC<LinkCuratorCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const image = firstImageProperty(entity, filter(['image', 'openGraph.image', 'banner.thumbnail', 'banner.image' ]))

  const entityImageAugment: Link = {
    ...entity,
    openGraph: {
      id: 'og-' + entity?.id,
      image: image,
    },
  };

  return (
    <My.Container 
      {...cardProps}
      entity={entityImageAugment}
      imageProps={{ showIcon: false }}
      className={cls.name(className)}
      colors={{ background: VERY_LIGHT_BROWN }}
      foot={
        <My.FootMeta entity={entityImageAugment} />
      }
    />
  )
};

LinkCuratorCard.defaultProps = LinkCuratorCardDefaultProps;
LinkCuratorCard.cls = cls;